































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { getClient, updateClient, getClientProducts, deleteClientProduct } from '@/api/clients'
import { AppModule } from '@/store/modules/app'
import { TagsViewModule, ITagView } from '@/store/modules/tags-view'
import { ClientModule, defaultClient } from '@/store/modules/clients'
import Sticky from '@/components/Sticky/index.vue'
import { Form } from 'element-ui'
import ClientInformation from './ClientInformation.vue'
import ProductsTable from './ProductsTable.vue'
import { IProduct } from '@/api/types-client'
import ProductEdit from './ProductEdit.vue'
import { defaultProduct } from '@/store/modules/products'

@Component({
  name: 'ClientEdit',
  components: {
    ClientInformation,
    ProductsTable,
    ProductEdit,
    Sticky
  }
})
export default class extends Vue {
  @Prop({ default: false }) private isEdit!: boolean
  @Prop({ default: false }) private isCreate!: boolean
  clientForm = Object.assign({}, defaultClient)
  loading = false
  tempTagView?: ITagView
  productList: IProduct[] = []
  productListLoading = false

  validateRequire = (rule: any, value: string, callback: Function) => {
    if (value === '') {
      if (rule.field === 'imageURL') {
        this.$message({
          message: 'Upload cover image is required',
          type: 'error'
        })
      } else {
        this.$message({
          message: rule.field + ' is required',
          type: 'error'
        })
      }
      callback(new Error(rule.field + ' is required'))
    } else {
      callback()
    }
  }

  rules = {
    name: [{ validator: this.validateRequire }],
    company: [{ validator: this.validateRequire }],
    phone: [{ validator: this.validateRequire }]
  }

  get lang() {
    return AppModule.language
  }

  get getTitle() {
    return `Client ${this.clientForm.clientId} - ${this.clientForm.name}`
  }

  productEditVisible = false
  productEdit:IProduct = Object.assign({}, defaultProduct)

  handleAddProduct() {
    console.log(`Handle Add Product! ${this.clientForm.clientId}`)
    this.productEdit = this.newProductForm()
    this.productEdit.clientId = this.clientForm.clientId
    this.productEditVisible = true
  }

  handleEditProduct(productId: number) {
    console.log(`Handle Edit Product! # ${productId}`)
    this.productList.forEach(p => {
      if (p.productId === productId) {
        this.productEdit = Object.assign({}, p)
      }
    })
    this.productEditVisible = true
  }

  async handleDeleteProduct(productId: number) {
    this.loading = true

    await deleteClientProduct(this.clientForm.clientId, productId)
    await this.getProducts(this.clientForm.clientId)
    this.loading = false
    this.$notify({
      title: 'Success',
      message: `Client Product ${productId} removed successfully.`,
      type: 'success',
      duration: 2000
    })
  }

  async handleEditClose() {
    this.productEditVisible = false
    this.$nextTick(async() => {
      this.loading = true
      await this.getProducts(this.clientForm.clientId)
      this.loading = false
    })
  }

  newProductForm(): IProduct {
    const result: IProduct = Object.assign({}, defaultProduct)
    result.productId = 0
    return result
  }

  created() {
    if (this.isEdit) {
      let clientId = 0
      if (!this.isCreate) {
        const id = this.$route.params && this.$route.params.id
        clientId = parseInt(id)
      }
      this.fetchData(clientId)
    }
    this.tempTagView = Object.assign({}, this.$route)
    console.log(`created ${this.tempTagView?.path}, ${this.tempTagView?.name}`)
  }

  private async fetchData(id: number) {
    try {
      if (id === 0) {
        this.clientForm = Object.assign({}, defaultClient)
      } else {
        const { data } = await getClient(id)
        this.clientForm = data
      }
      ClientModule.setSelectedClient(this.clientForm)
      await this.getProducts(id)
      const title = this.getTitle
      this.setTagsViewTitle(title)
      this.setPageTitle(title)
    } catch (err) {
      console.error(err)
    }
  }

  async getProducts(id: number) {
    this.productListLoading = true
    const { data } = await getClientProducts(id)
    this.productList = data || []
    this.productListLoading = false
  }

  private setTagsViewTitle(title: string) {
    const tagView = this.tempTagView
    if (tagView) {
      tagView.title = title
      TagsViewModule.updateVisitedView(tagView)
    }
  }

  private setPageTitle(title: string) {
    document.title = title
  }

  private closeTagView() {
    const tagView = this.tempTagView
    if (tagView) {
      TagsViewModule.delView(tagView)
      this.toLastView(TagsViewModule.visitedViews, tagView)
    }
  }

  private toLastView(visitedViews: ITagView[], view: ITagView) {
    const latestView = visitedViews.slice(-1)[0]
    if (latestView !== undefined && latestView.fullPath !== undefined) {
      this.$router.push(latestView.fullPath).catch(err => {
        console.warn(err)
      })
    } else {
      // Default redirect to the home page if there is no tags-view, adjust it if you want
      if (view.name === 'Dashboard') {
        // to reload home page
        this.$router.replace({ path: '/redirect' + view.fullPath }).catch(err => {
          console.warn(err)
        })
      } else {
        this.$router.push('/').catch(err => {
          console.warn(err)
        })
      }
    }
  }

  private submitForm() {
    (this.$refs.clientForm as Form).validate(async valid => {
      if (valid) {
        this.loading = true

        const { data } = await updateClient(this.clientForm.clientId, this.clientForm)
        this.clientForm = data
        this.loading = false
        this.$notify({
          title: 'Success',
          message: `Client ${this.clientForm.clientId} saved successfully.`,
          type: 'success',
          duration: 2000
        })
        this.closeTagView()
        return true
      } else {
        console.log('Validation errors!')
        this.loading = false
        return false
      }
    })
  }

  private cancelForm() {
    this.closeTagView()
    return true
  }
}
